import type { Dispatch, SetStateAction } from 'react';

import { useTranslation } from 'react-i18next';

import { FormControlLabel } from '@packages/fenrir/components/form-control-label';
import { FormLabel } from '@packages/fenrir/components/form-label';
import { Radio } from '@packages/fenrir/components/radio';
import { RadioGroup } from '@packages/fenrir/components/radio-group';
import { Stack } from '@packages/fenrir/components/stack';
import { Typography } from '@packages/fenrir/components/typography';

type SourceSelectorProps = {
  setSelectedSource: Dispatch<SetStateAction<string>>;
};

export const SourceSelector: React.FC<SourceSelectorProps> = ({
  setSelectedSource,
}) => {
  const { t: tSource } = useTranslation('ads', {
    keyPrefix: 'source',
  });

  const { t: tRescanCommon } = useTranslation('ads', {
    keyPrefix: 'assetRescanCommon',
  });

  return (
    <Stack spacing={2}>
      <Typography variant="body1">
        {tRescanCommon('sourceSelection')}
      </Typography>
      <Stack>
        <FormLabel id="source-selector-group-label">
          {tRescanCommon('sources')}
        </FormLabel>

        <RadioGroup
          aria-labelledby="source-selector-group-label"
          name="source-selector"
          onChange={(e) => {
            setSelectedSource(e.target.value);
          }}
          defaultValue="all"
        >
          <FormControlLabel
            value="all"
            control={<Radio />}
            label={tSource('all')}
          />
          <FormControlLabel
            value="agent"
            control={<Radio />}
            label={tSource('agent')}
          />
          <FormControlLabel
            value="iva"
            control={<Radio />}
            label={tSource('iva')}
          />
        </RadioGroup>
      </Stack>
    </Stack>
  );
};
